import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Components
import Popup from '../../Popup';
import Container from '../../Container';
import MobileMenu from '../../MobileMenu';
import AddressButton from '../../AddressButton/DesktopView';

// Router
import { getRoute } from '../../../entry/routes';

import { getHeaderLogoSrc } from '../headerLogo';
import { CITY_THEME_DISNEY, CITY_THEME_MOTHERS_DAY, isThemeActive, isVisualThemeActive } from '../../../utils/cityTheme';

// Config
import config from '../../../config';

import styles from './TabletView.styl';

const cx = classNames.bind(styles);

export default function TabletView(props) {
  const { className } = props;

  const locale = useSelector(state => state.intl.locale);
  const userCity = useSelector(state => state.city.userCity);
  const { isOpen: isAuthOpen } = useSelector(state => state.popup.list?.auth) || {};
  const [isOpen, setIsOpen] = useState(false);

  const lang = config.legal === 'kz' || config.legal === 'kg' ? 'en' : locale;
  const logoSrc = getHeaderLogoSrc(lang, userCity);
  const isDisneyTheme = isVisualThemeActive(userCity, CITY_THEME_DISNEY);
  const isMothersDayTheme = isThemeActive(userCity, CITY_THEME_MOTHERS_DAY);

  const toggle = () => {
    setIsOpen(prev => !prev);
  };

  useEffect(() => {
    if (isAuthOpen) {
      setIsOpen(true);
    }
  }, [isAuthOpen]);

  return (
    <header className={cx('Header', className)}>
      <Container className={cx('Header__container')}>
        <Link
          to={getRoute('home')}
          className={cx('Header__logo', {
            Header__logo_disney: isDisneyTheme,
            Header__logo_mothersDay: isMothersDayTheme,
          })}
        >
          <img src={logoSrc} alt="Papa John's" />
        </Link>
        <AddressButton />
        <div
          className={cx('Header__hamburger')}
          onClick={toggle}
          onKeyDown={e => e.key === 'Enter' && toggle()}
          role="button"
          tabIndex={0}
        >
          <div className={cx('Header__hamburger-line')} />
          <div className={cx('Header__hamburger-line')} />
          <div className={cx('Header__hamburger-line')} />
        </div>
        <Popup className={cx('Header__popup')} isOpen={isOpen}>
          <MobileMenu onClose={toggle} />
        </Popup>
      </Container>
    </header>
  );
}

TabletView.defaultProps = {
  className: '',
};

TabletView.propTypes = {
  className: PropTypes.string,
};
